<div>
  <p class="offer-hint">Choose a coffee and supplier, or enter their names manually.</p>
  <form #SampleForm="ngForm">
    <div>
      @if(!OfferSample.ManuallyEnterName){<rms-search-select [required]="!OfferSample.ManuallyEnterName" [options]="Products" name="SampleProductID" labelKey="InventoryTypeName" valueKey="InventoryTypeID" label="Product Name" [(ngModel)]="OfferSample.InventoryTypeID"></rms-search-select>}
      @else{<rms-input label="Name" name="SampleProductName" [required]="OfferSample.ManuallyEnterName" [(ngModel)]="OfferSample.InventoryTypeName"></rms-input>}
      <rms-checkbox [small]="true" name="SampleProductManual" label="Manually Enter Name" [(ngModel)]="OfferSample.ManuallyEnterName"></rms-checkbox>
    </div>
    <div>
      @if(OfferSample.ManuallyEnterSupplier){
      <rms-input label="Supplier" name="SampleSupplierName" [required]="OfferSample.ManuallyEnterSupplier" [(ngModel)]="OfferSample.SupplierName"></rms-input>
      }
      @else{
      <rms-search-select [required]="!OfferSample.ManuallyEnterSupplier" [options]="Suppliers" name="SampleSupplierID" labelKey="SupplierName" valueKey="SupplierID" label="Supplier" [(ngModel)]="OfferSample.SupplierID"></rms-search-select>
      }
      <rms-checkbox [small]="true" name="SampleSupplierManual" label="Manually Enter Supplier" [(ngModel)]="OfferSample.ManuallyEnterSupplier"></rms-checkbox>
    </div>
  </form>
  <div style="display:flex; gap:20px; justify-content:flex-end;width:100%">
    <button mat-button class="btn-bg-green" [disabled]="!SampleForm.valid" (click)="save()">Save</button>
    @if(OfferSample.WasApproved && OfferSample.InventoryTypeID && OfferSample.SupplierID && !SampleForm.dirty && !OfferSample.InventoryCreated){
    <button mat-button class="btn-bg-green" (click)="createPurchaseOrder()">Create purchase order</button>
    }
    <button mat-button class="btn-bg-red" (click)="cancel()">Cancel</button>
  </div>
</div>
